import Colors from 'enums/Colors';
import React from 'react';
import { RiDoubleQuotesL } from 'react-icons/ri';
import styled from 'styled-components';

const Styled = {
    Container: styled.div`
        display: grid;
        grid-template-columns: auto 1fr;
        font-size: 18px;
        background-color: #f1bc40;
        color: ${Colors.White};
        padding: 20px;
        border-radius: 20px;
        gap: 20px;
    `,
};

interface QuoteProps {
    text: string;
    styles?: React.CSSProperties;
}

const Quote: React.FC<QuoteProps> = ({ text, styles }) => {
    return (
        <Styled.Container style={styles}>
            <RiDoubleQuotesL style={{ fontSize: '40px' }} />
            <p dangerouslySetInnerHTML={{__html: text}}/>
        </Styled.Container>
    );
};

export default Quote;
